interface WavelengthRangeBand {
    name: string;
    from: number;
    to: number;
}

interface WavelengthRange {
    min: number;
    max: number;
    step: number;
    stepNum: number;
    ranges: WavelengthRangeBand[];
}

const min = 200;
const max = 1050;
const step = 5;

const waveLengthRange: WavelengthRange = {
    min,
    max,
    step,
    stepNum: (max - min) / step + 1,
    ranges: [
        {
            name: 'uvC',
            from: min,
            to: 279
        },
        {
            name: 'uvB',
            from: 280,
            to: 319
        },
        {
            name: 'uvA',
            from: 320,
            to: 399
        },
        {
            name: 'uv',
            from: 100,
            to: 399
        },
        {
            name: 'blue',
            from: 400,
            to: 499
        },
        {
            name: 'green',
            from: 500,
            to: 599
        },
        {
            name: 'red',
            from: 600,
            to: 699
        },
        {
            name: 'fr',
            from: 700,
            to: 780
        },
        {
            name: 'ir',
            from: 781,
            to: max
        },
        {
            name: 'sum',
            from: min,
            to: max
        },
        {
            name: 'visibleSum',
            from: 400,
            to: 700
        }
    ]
};

export default waveLengthRange;
